import marketFiltersMixin from '@/components/market/market-filters/market-filters-mixin/market-filters-mixin';

export default {
  mixins: [
    marketFiltersMixin,
  ],
  computed: {
    orderMenuName() {
      return this.selectedOrder.name;
    },
    mainClassName() {
      return 'market-filters-mobile';
    },
    menuClassModifier() {
      return {
        'market-filters-mobile__menu': true,
        'market-filters-mobile__menu--with-timespan-filter': this.shouldShowTimespanFilter,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-filters/market-filters-mobile/market-filters-mobile.js